import clsx from 'clsx';
import type * as React from 'react';

import * as api from '@gitbook/api-client';
import { Picker, type PickerItemData } from '@gitbook/react-uikit';
import { FieldGroup, Label } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../types';

/**
 * Settings to configure the style for corners
 */
export function ThemeDepthSettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;

    return (
        <FieldGroup orientation="horizontal">
            <Label>Depth style</Label>
            <Picker
                value={settings.styling.depth}
                items={OPTIONS}
                onValueChange={(value) => {
                    setSettings((prev) => ({
                        ...prev,
                        styling: {
                            ...prev.styling,
                            depth: value,
                        },
                    }));
                }}
            />
        </FieldGroup>
    );
}

const OPTIONS: PickerItemData<api.CustomizationDepth>[] = [
    {
        value: api.CustomizationDepth.Subtle,
        label: 'Subtle',
        subtitle: 'Some shadows and elevation',
        icon: <DepthIcon value={api.CustomizationDepth.Subtle} />,
    },
    {
        value: api.CustomizationDepth.Flat,
        label: 'Flat',
        subtitle: 'No shadows, no elevation',
        icon: <DepthIcon value={api.CustomizationDepth.Flat} />,
    },
];

/**
 * Small illustration to show the difference between depth styles.
 */
function DepthIcon(props: {
    value: api.CustomizationDepth;
    size?: number;
    className?: string;
}): React.ReactElement {
    const { value, className, size } = props;

    return (
        <div
            className={clsx('relative flex overflow-hidden rounded-sm border bg-base', className)}
            style={{
                width: size,
                height: size,
            }}
        >
            <div
                className={clsx(
                    'absolute top-0 left-0 size-2/3 rounded-br-sm border-control border-r border-b bg-muted',
                    value === api.CustomizationDepth.Subtle && 'shadow'
                )}
            />
        </div>
    );
}
